import React, { useMemo } from "react";

import BaseDropdown from "components/form/BaseDropdown";

import Context from "../Context";

interface OperatorDropdownProps {
  id: number;
  combinator: string;
  attribute?: string;
  operator?: string;
}

const OperatorDropdown = ({
  id,
  combinator,
  attribute,
  operator,
}: OperatorDropdownProps): JSX.Element => {
  const context = React.useContext(Context);

  const { dispatchAction, attributes, operators, labels } = context;

  const value = operator ?? null;

  const values = useMemo(() => {
    const attributeSpec = attribute ? attributes[attribute] : null;
    const options = attributeSpec
      ? operators[attributeSpec.type].filter((o) =>
          o.combinators.includes(combinator)
        ) ?? []
      : [];
    return options.map((key) => ({
      id: key.operator,
      label: key.label,
      selected: key.operator === value,
    }));
  }, [attribute, attributes, operators, combinator, value]);

  return (
    <BaseDropdown
      required
      status="valid"
      singleSelectionToggle={false}
      label={labels.rule.operator.label}
      placeholder={labels.rule.operator.placeholder}
      values={values}
      disabled={values.length === 0}
      onChange={(selected) => {
        if (selected && !Array.isArray(selected) && selected.id) {
          dispatchAction({
            type: "set-operator",
            id,
            operator: selected.id,
            value:
              value === "range" || selected.id === "range" ? null : undefined,
          });
        } else {
          dispatchAction({
            type: "set-operator",
            id,
            operator: null,
            value: null,
          });
        }
      }}
    />
  );
};

export default React.memo(OperatorDropdown);
